import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your answers, it seems like this dizziness is most likely due to  <strong>aging</strong> </h2>
        <p>As people get older, their entire balance system gets affected. </p>
        <p>Progressive hearing, vision, and muscle/bone density loss all contribute to an increased likelihood of dizziness. This is what puts the older populations at a much higher risk of dangerous falls. </p>
        <p>Working on your balance skills as you age helps to keep your balance system functional and you feeling more in control</p>
        <a id="Aging" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
